import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const xrf = {
    jpath: ['spectra', 'xrf'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xrf;
//# sourceMappingURL=xrf.js.map